// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"53030d7c","342":"9a2c83ca","615":"7d33d16a"}[chunkId] + ".chunk.css";
};